<template>
  <v-container fluid fill-height pa-0>
    <v-layout max row wrap class="faq">
      <v-flex v-if="faq.length" xs12 mb-3>
        <div class="page-title">Часто задаваемые вопросы</div>
        <v-expansion-panels v-if="faq.length" class="faq-list">
          <v-expansion-panel v-for="(item, i) in faq" :key="i">
            <v-expansion-panel-header><div class="form-title">{{item.question}}</div></v-expansion-panel-header>
            <v-expansion-panel-content>
              <span v-html="item.answer"></span>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'FaqPage',
  computed: {
    faq() {
      return this.$store.state.faq.list;
    },
  },
  mounted() {
    this.$store.dispatch('faq/GetList');
  },
};
</script>

<style scoped>
  .faq-list {
    border-radius: 16px;

    .v-expansion-panel{
      border-radius: 16px !important;
    }
  }
</style>
